import { takeEvery, put, select } from "redux-saga/effects";
import { push as pushHistory, replace as replaceHistory, go, goBack } from "connected-react-router";
import { clearRedirectUrl, redirect } from "redux/reducers/redirect";
import { RedirectSelector } from "redux/selector/redirect-selector";
import { eventChannel } from "redux-saga";
import { history } from "redux/store";

export function createLocationChangeChannel() {
  return eventChannel((emit) => {
    const unsubscribe = history.listen((location, action) => {
      emit({ location, action });
    });
    return unsubscribe;
  });
}

export function* redirectToSaga({ payload: id }) {
  const redirectInfo = (yield select(RedirectSelector.state))[id];
  if (redirectInfo) {
    const { url, replace, dispatchAction, dispatchActions, backStep } = redirectInfo;

    if (dispatchAction) {
      yield put({ ...dispatchAction });
    }

    if (dispatchActions && Array.isArray(dispatchActions)) {
      for (const action of dispatchActions) {
        yield put({ ...action });
      }
    }

    if (url) {
      if (url === "GO_BACK") {
        if (backStep) yield put(go(Math.abs(backStep) * -1));
        else yield put(goBack());
      } else {
        const redirectMethod = replace ? replaceHistory : pushHistory;
        yield put(redirectMethod(url));
      }
    }

    yield put(clearRedirectUrl(id));
  }
}

const saga = [takeEvery(redirect.type, redirectToSaga)];

export default saga;
